import { render, staticRenderFns } from "./nextageFooter.vue?vue&type=template&id=791eb9cd&scoped=true&"
import script from "./nextageFooter.vue?vue&type=script&lang=ts&"
export * from "./nextageFooter.vue?vue&type=script&lang=ts&"
import style0 from "./nextageFooter.vue?vue&type=style&index=0&id=791eb9cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791eb9cd",
  null
  
)

export default component.exports